import { DataBean } from "../DataBean";

export class ImportCostSettlement extends DataBean {


    public async getImportCostSettlementCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "java.util.List_getImportCostSettlementCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }


 
}